import type { Resource } from '../../';
export const product_sizeChart_showMoreCountries: Resource = {"default":"More Countries"};
